module.exports = __webpack_public_path__ + "static/media/medalla.047c298b.png";